import copy from "copy-to-clipboard"
import { useTranslation } from "react-i18next"
import { Button } from "ui/@button"
import Container from "ui/container"
import { transactionCancelled } from "assets/icons"
import "./index.scss"

const DefaultError = ({ error }: { error: Error }) => {
  const { t } = useTranslation()

  return (
    <div className="default-error fullscreen">
      <img
        className="default-error__image"
        src={transactionCancelled}
        width="90px"
        height="90px"
      />
      <h1>{t("errorOops")}</h1>
      <h2>{t("errorItSeems")}</h2>
      <Container className="error-info">
        {error.name && (
          <>
            <p>
              <span>Name:</span> {error.name}
            </p>
            <hr />
          </>
        )}
        {error.message && (
          <>
            <p>
              <span>Message:</span> {error.message}
            </p>
            <hr />
          </>
        )}
        {error.stack && (
          <p>
            <span>Details:</span> {error.stack}
          </p>
        )}
      </Container>
      <h3>{t("errorPleaseCopy")}</h3>
      <Button
        onClick={() => {
          copy(
            JSON.stringify({
              name: error.name,
              message: error.message,
              stack: error.stack
            })
          )
        }}
      >
        {t("copy")}
      </Button>
    </div>
  )
}

export default DefaultError
